<template>
    <div class="container">
        <ProfileTitle>
            <template v-slot:header>
                <h1  class="main__title">Hello, {{ generalInfo.first_name }} {{ generalInfo.last_name }}</h1>
            </template>
        </ProfileTitle>

        <TabContainer
            :tabs="computedTabs"
            :space-between="false"
        />
    </div>
</template>


<script>
import ProfileTitle from "../Common/ProfileTitle.vue";
import TabContainer from "../Common/TabContainer.vue";
import {mapActions, mapState} from "pinia";
import {useClientStore} from "../../stores/ClientStore";
import ClientInformation from "./ClientInformation.vue";
import ClientAdditionalInformation from "./ClientAdditionalInformation.vue";
import MyArtists from "./MyArtists.vue";

export default {
    name: 'ClientProfile',
    components: {TabContainer, ProfileTitle},
    props: {
       clientId: Number
    },
    data() {
        return {
            showArtists: false,
        };
    },
    computed: {
        ...mapState(useClientStore, {
            generalInfo: 'generalClientInfo',

        }),
        computedTabs() {
            if (this.clientId) {
                return [
                    {id: 1, name: 'Client Information', component: ClientInformation},
                    {id: 2, name: 'Additional Information', component: ClientAdditionalInformation},
                    {id: 3, name: 'Client Artists', component: MyArtists}
                ];
            } else {
                return [
                    {id: 1, name: 'Client Information', component: ClientInformation},
                    {id: 2, name: 'Additional Information', component: ClientAdditionalInformation},
                ];
            }

        }
    },
    mounted() {
        this.fetchCompanies()
        this.fetchClient(this.clientId)
        this.setAdminPermission()
        if(this.clientId) {
            this.setClientId(this.clientId)
        }


    },
    methods: {
        ...mapActions(useClientStore, {
            fetchClient: 'fetchClient',
            fetchCompanies: 'fetchCompanies',
            setAdminPermission: 'setAdminPermission',
            fetchListOfArtists: 'fetchListOfArtists',
            setClientId: 'setClientId'
        }),
    },
}

</script>


<style scoped>

</style>
